module.exports = __webpack_public_path__ + "static/media/086-nigeria.9a70e44e.svg";